export enum UserItExperienceEnum {
    NONE = 'NONE',
    POOR = 'POOR',
    PRETTY_WELL = 'PRETTY_WELL',
    VERY_GOOD = 'VERY_GOOD'
}

